import _slicedToArray from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import { Grid } from "@material-ui/core";
import { useAuth0 } from "../auth/react-auth0-wrapper";
import { CenterContainer, Footer, Header } from ".";
import Sidebar from "./Sidebar";
var DefaultLayout = function DefaultLayout(_ref) {
  var children = _ref.children,
    hideLogin = _ref.hideLogin,
    _ref$hideOverflow = _ref.hideOverflow,
    hideOverflow = _ref$hideOverflow === void 0 ? false : _ref$hideOverflow,
    centerStyle = _ref.centerStyle,
    _ref$hideSidebar = _ref.hideSidebar,
    hideSidebar = _ref$hideSidebar === void 0 ? false : _ref$hideSidebar,
    _ref$hideHamburger = _ref.hideHamburger,
    hideHamburger = _ref$hideHamburger === void 0 ? false : _ref$hideHamburger,
    _ref$showV2ProfileLin = _ref.showV2ProfileLinks,
    showV2ProfileLinks = _ref$showV2ProfileLin === void 0 ? false : _ref$showV2ProfileLin,
    _ref$isOnlyForLoading = _ref.isOnlyForLoading,
    isOnlyForLoading = _ref$isOnlyForLoading === void 0 ? false : _ref$isOnlyForLoading;
  var _useAuth = useAuth0(),
    selectedInstitution = _useAuth.selectedInstitution;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 1),
    hiddenSidebar = _useState2[0];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 1),
    localHideHamburger = _useState4[0];
  return React.createElement(Grid, {
    container: true,
    direction: "column",
    style: {
      minHeight: "100vh"
    }
  }, React.createElement(Grid, {
    item: true,
    style: {
      width: "200px",
      border: "2px",
      height: "60px",
      paddingLeft: "0px",
      alignItems: "left"
    }
  }, React.createElement(Header, {
    isOnlyForLoading: isOnlyForLoading,
    hideLogin: hideLogin,
    showHamburger: !hideHamburger && !localHideHamburger,
    showV2ProfileLinks: showV2ProfileLinks,
    institutionCode: selectedInstitution === null || selectedInstitution === void 0 ? void 0 : selectedInstitution.institutionCode
  })), React.createElement(Grid, {
    item: true,
    style: {
      flex: 1,
      display: "flex",
      height: "auto",
      minHeight: "auto",
      maxHeight: "auto"
    }
  }, React.createElement(Grid, {
    item: true,
    style: {
      width: !hiddenSidebar ? "0px" : "0px",
      transition: "width 0.3s ease",
      overflow: "hidden"
    }
  }, React.createElement(Sidebar, {
    hide: !hiddenSidebar
  })), React.createElement(Grid, {
    item: true,
    style: {
      paddingLeft: "0px",
      width: "100%",
      height: "auto",
      minHeight: "auto",
      maxHeight: "none",
      flex: 1
    }
  }, React.createElement(CenterContainer, {
    style: Object.assign({
      width: "100%",
      maxWidth: "100%",
      height: "auto",
      minHeight: "auto",
      maxHeight: "none"
    }, centerStyle)
  }, children))), React.createElement(Grid, {
    item: true,
    style: {
      height: "40px",
      marginTop: "auto"
    }
  }, React.createElement(Footer, null)));
};
export default DefaultLayout;